import React from 'react';
import {Flex, Text} from '@priority-software/priority-style-react';
import {texts} from '../../texts';

const renderText = (text: string) => {
    const parts = text.split(/(@)/g);
    let isBold = false;
    return parts.map((part, idx) => {
        if (part === '@') {
            isBold = !isBold;
            return '';
        }
        return isBold ? (
            <Text tag="span" key={`bold-${idx}`} fontWeight="bold">
                {part}
            </Text>
        ) : (
            part
        );
    });
};

const renderBullets = (part: string) => {
    const bullets = part.split('\n');
    return bullets.map((bullet, idx) => {
        return (
            <li key={`bullet-${idx}`}>
                <Text tag="span">{renderText(bullet)}</Text>
            </li>
        );
    });
};

const renderContent = (parts: string[]) => {
    let isBullets = false;
    return parts.map((part, idx) => {
        if (part === '#') {
            isBullets = !isBullets;
            return '';
        }
        if (isBullets) {
            return (
                <ul key={`ul-${idx}`} style={{marginInlineStart: '20px'}}>
                    {renderBullets(part)}
                </ul>
            );
        } else {
            const isBold = part.includes('@');
            return <Text key={`text-${idx}`}>{isBold ? renderText(part) : part}</Text>;
        }
    });
};

export const HelpContent = () => {
    const serverText = texts.helpbok_text;
    const parts = serverText.split(/(#)/g);
    if (parts) {
        return (
            <Flex>
                <Text skin="paragraph-2" textColor="primary-700" key={'helpContent'}>
                    {renderContent(parts)}
                </Text>
            </Flex>
        );
    } else {
        return null;
    }
};
